import * as React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
// import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import operatorActions from 'redux/actions/user'
import { nxAuthTokenAct } from 'redux_new/actions'
import { signup as apiSignup } from 'api'

import LandingLocale from 'components/common/LandingLocale'
import { SignupErrorInvalidToken, SignupLoadInit } from "components/account"

import {
  StepOne,
  StepTwo,
  StepThree,
} from "../../../components/account/signup/Steps"
import "./styles.scss"
import { getStaticImage } from 'utils/statics'

function useQuery({ search }) {
  return new URLSearchParams(search)
}

/**
 *
 */
const Signup = (props) => {
  const dispatch = useDispatch()
  const locale = useSelector(store => store?.i18n?.locale)
  const operatorActs = bindActionCreators(operatorActions, dispatch)
  const onNxAuthToken = bindActionCreators(nxAuthTokenAct, dispatch)

  const { actionRegister } = props
  const tokenOperator = props.match.params.token

  let query = useQuery(useLocation())
  const planSelected = query.get("plan") || "basic"
  const utmCampaign = query.get("utm_campaign") || ""

  const [loadingInit, setLoadingInit] = React.useState(false)
  const [errorTokenOperator, setErrorTokenOperator] = React.useState(false)
  const [isStepOne, setIsStepOne] = React.useState(true)
  const [isStepThree, setIsStepThree] = React.useState(false)
  const [dataRegister, setDataRegister] = React.useState({})
  const [step1ServiceErrors, setStep1ServiceErrors] = React.useState({})
  const [step2ServiceErrors, setStep2ServiceErrors] = React.useState({})
  const [tokenRegister, setTokenRegister] = React.useState("")
  const [loadingForm, setLoadingForm] = React.useState(false)
  const [errorGeneral, setErrorGeneral] = React.useState(false)

  // state form 1
  const [dataFormStep1, setDataFormStep1] = React.useState({
    name: "",
    lastname: "",
    email: "",
    password: "",
    terms: false,
  })
  // state form 2
  const [dataFormStep2, setDataFormStep2] = React.useState({
    companyName: "",
    nif: "",
    phone: "",
    registerType: "company",
    phoneCode: "",
  })

  // const isMobile = useMediaQuery({
  //   query: "(max-width: 760px)",
  // });

  // ir al paso 2
  const goToStepTwo = (values) => {
    setLoadingForm(true)
    setErrorGeneral(false)
    setDataRegister({ ...dataRegister, ...values })

    setDataFormStep1(values)

    // si es un operador llamaos al registrar operador
    if (actionRegister === "operator") {
      registerOperator(values)
      return
    }

    const bodyData = {
      name: values.name,
      lastname: values.lastname,
      email: values.email,
      password: values.password,
      terms: values.terms,
    }

    // validamos los datos
    apiSignup
      .validateFields(bodyData)
      .then(() => {
        setIsStepOne(false)
      })
      .catch(({ response: { data, status } }) => {
        if (status) {
          if (data.type && data.type === "error_invalid_fields") {
            setStep1ServiceErrors(data.fields)
          } else {
            setErrorGeneral(true)
          }
        } else {
          setErrorGeneral(true)
        }
      })
      .finally(setLoadingForm(false))
  }

  // registrar operador
  const registerOperator = (values) => {
    const dataBody = {
      token: tokenOperator,
      name: values.name,
      lastname: values.lastname,
      password: values.password,
      terms: values.terms,
      locale: locale
    }

    apiSignup
      .signupOperator(dataBody)
      .then(({ data }) => {
        onNxAuthToken.add(data.token)
        return data.token
      })
      .then((authToken) => {
        operatorActs.getOperator(authToken, true)
      })
      .catch((error) => {
        console.error(error)
        const { data } = error
        if (data && data.type) {
          if (data.type === "error_signup_token_not_valid") {
            setErrorGeneral(true)
          } else if (data.type && data.type === "error_invalid_fields") {
            setStep1ServiceErrors(data.fields)
          } else {
            setErrorGeneral(true)
          }
        } else {
          setErrorGeneral(true)
        }

        setLoadingForm(false)
      })
  }

  // ir paso 3
  const goToStepThree = (values) => {
    setErrorGeneral(false)
    setLoadingForm(true)

    setDataFormStep2(values)

    const bodyData = {
      ...dataRegister,
      locale: locale
    }
    bodyData.registerType = values.registerType
    bodyData.nif = values.nif
    bodyData.planSelected = planSelected
    bodyData.utmCampaign = utmCampaign

    bodyData.registerType = values.registerType
    if (values.registerType === "company") {
      bodyData.companyName = values.companyName
    }

    if (values.phone) {
      bodyData.phone = values.phone
      bodyData.phoneCode = values.phoneCode
    }

    bodyData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    setDataRegister(bodyData)

    apiSignup
      .signupCompany(bodyData)
      .then(({ data }) => {
        setTokenRegister(data.token)
        setIsStepOne(false)
        setIsStepThree(true)
      })
      .catch(({ data, status }) => {
        if (status) {
          if (data.type && data.type === "error_invalid_fields") {
            setStep2ServiceErrors(data.fields)
          } else {
            setErrorGeneral(true)
          }
        } else {
          setErrorGeneral(true)
        }
        setLoadingForm(false)
      })
  }

  const changeEmail = (newEmail) => {
    const dataBody = {
      token: tokenRegister,
      oldEmail: dataRegister.email,
      newEmail: newEmail,
    }

    // request change email
    apiSignup.signupChangeEmail(dataBody)
  }

  // verificar si el token para registrar el operador es valido
  const checkTokenOperator = () => {
    apiSignup
      .checkTokenOperator(tokenOperator)
      .catch(() => {
        setErrorTokenOperator(true)
      })
      .finally(() => setLoadingInit(false))
  }

  const goToStepOne = (values) => {
    setDataFormStep2(values)
    setIsStepOne(true)
  }

  const renderLogo = () => {
    return (
      <div className="logo">
        <svg width="138" height="31" viewBox="0 0 138 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Logo">
            <path id="Vector" d="M26.0074 2.39913C24.2735 1.45602 22.3272 0.974637 20.3546 1.00103C19.2518 1.00027 18.1533 1.13733 17.0843 1.40908C16.0534 1.66706 15.0661 2.07618 14.1544 2.62322C13.264 3.134 12.5239 3.87126 12.0087 4.76051C11.8315 5.08949 11.6884 5.43582 11.5816 5.79405C11.3547 6.5533 11.2245 7.152 11.1778 7.37275C11.1547 7.48608 11.0933 7.58793 11.0039 7.66107C10.9145 7.73421 10.8027 7.77415 10.6873 7.77413C10.5845 7.77512 10.4841 7.7435 10.4003 7.68381L8.60836 6.45295L9.60946 1.43584H1V30.9933H9.7029V16.4102C9.7029 14.2094 10.3036 12.3598 11.4915 10.9115C12.6795 9.46322 14.368 8.67052 16.447 8.63373C18.2189 8.63373 19.6538 9.21235 20.7116 10.3529C21.7695 11.4935 22.2967 13.0287 22.2967 14.9453V31H30.9962V12.236C31.0462 10.1676 30.5987 8.11747 29.6915 6.25895C28.8778 4.63528 27.5999 3.29149 26.0208 2.39913" fill="white"/>
            <path id="Vector_2" d="M47 2H39V31H47V2Z" fill="white"/>
            <path id="Vector_3" d="M100 2H92V31H100V2Z" fill="white"/>
            <path id="Vector_4" d="M71.4037 15.8672C72.0242 15.8708 72.6381 15.7409 73.2022 15.4868C74.3754 14.9301 75.4315 14.1615 76.3155 13.221L86.7097 2.30495L87 2H76.232L75.3778 2.89518L70.5728 7.94165C70.3075 8.28111 69.9256 8.51419 69.4984 8.59747C69.0684 8.51874 68.6839 8.28481 68.4205 7.94165L63.6189 2.89846L62.7646 2.00328H52L52.2903 2.30823L62.6779 13.221C63.5626 14.1679 64.624 14.9393 65.8045 15.4933C66.3658 15.7449 66.9761 15.8735 67.593 15.8704H68.0368V17.1296H67.5997C66.981 17.1271 66.3693 17.258 65.8078 17.5132C64.6291 18.0657 63.5689 18.8348 62.6845 19.7791L52.2903 30.6918L52 30.9967H62.7713L63.6255 30.1048L68.4272 25.0551C68.6038 24.8695 68.8033 24.7065 69.0212 24.5698C69.1655 24.4782 69.3305 24.423 69.5016 24.4091C69.792 24.4091 70.1691 24.6485 70.5795 25.0649L75.3778 30.1048L76.232 31H87L86.7097 30.6951L76.3221 19.7856C75.4384 18.8413 74.3795 18.0711 73.2022 17.5165C72.6394 17.2616 72.0267 17.1306 71.407 17.1329H70.9632V15.8737L71.4037 15.8672Z" fill="white"/>
            <path id="Vector_5" d="M115.19 2C115.139 4.04096 114.515 5.76035 113.381 7.12208C112.159 8.56913 110.476 9.32054 108.373 9.35664C107.913 9.35754 107.453 9.3169 107 9.23523V16.5919C108.39 16.3598 109.721 15.8732 110.924 15.1579L110.958 15.135C112.109 14.4259 112.95 13.3287 113.32 12.0539C113.587 11.1646 113.718 10.5182 113.718 10.5117L113.766 10.2754L115.875 9.5043C115.915 9.48908 115.959 9.48439 116.002 9.4907C116.045 9.497 116.085 9.51407 116.119 9.54025C116.153 9.56642 116.18 9.60079 116.196 9.63994C116.212 9.6791 116.218 9.72168 116.212 9.76351L115.443 15.1875C115.282 16.3138 115.202 17.4497 115.203 18.5869V31H124V2H115.19Z" fill="#E87721"/>
            <path id="Vector_6" d="M133.986 7.99029C133.585 7.99418 133.187 7.91463 132.818 7.75669C132.46 7.60877 132.135 7.39127 131.861 7.11671C131.588 6.84196 131.371 6.51574 131.223 6.15675C131.073 5.79037 130.997 5.3977 131 5.0016C130.999 4.60292 131.077 4.20796 131.23 3.84005C131.38 3.4824 131.596 3.15663 131.868 2.88008C132.143 2.60712 132.468 2.38985 132.825 2.24011C133.197 2.07823 133.599 1.99647 134.005 2.00012C134.407 1.99763 134.806 2.07823 135.175 2.2369C135.533 2.3849 135.859 2.60239 136.132 2.87688C136.406 3.15184 136.622 3.47801 136.77 3.83684C136.925 4.2044 137.003 4.5996 137 4.9984C137.002 5.39714 136.924 5.79222 136.77 6.15996C136.621 6.51797 136.404 6.84387 136.132 7.11992C135.856 7.39178 135.532 7.60891 135.175 7.75989C134.803 7.92177 134.401 8.00353 133.995 7.99988M133.995 7.42391C134.324 7.4283 134.65 7.364 134.952 7.23511C135.241 7.11063 135.503 6.93137 135.724 6.70714C135.946 6.48501 136.122 6.22067 136.241 5.92957C136.367 5.62555 136.43 5.29889 136.426 4.96961C136.428 4.64776 136.365 4.32881 136.241 4.03205C136.122 3.7431 135.949 3.48006 135.73 3.25767C135.512 3.03548 135.251 2.8583 134.965 2.73608C134.663 2.605 134.337 2.53957 134.008 2.5441C133.679 2.54146 133.353 2.60681 133.051 2.73608C132.763 2.8583 132.501 3.03667 132.282 3.26087C132.065 3.48698 131.892 3.75178 131.772 4.04164C131.645 4.34553 131.582 4.67228 131.587 5.0016C131.585 5.3231 131.647 5.64175 131.769 5.93916C131.884 6.23111 132.056 6.49671 132.276 6.71993C132.493 6.94307 132.752 7.12041 133.038 7.24151C133.341 7.36825 133.667 7.43141 133.995 7.42711M132.866 6.38395V3.42407H134.075C134.394 3.40362 134.71 3.49651 134.968 3.68646C135.074 3.77872 135.159 3.89412 135.214 4.02387C135.269 4.15362 135.294 4.29429 135.287 4.43522C135.293 4.58171 135.268 4.72786 135.213 4.8637C135.158 4.99953 135.074 5.12187 134.968 5.22239C134.717 5.42754 134.398 5.52935 134.075 5.50719H133.437V6.38395H132.866ZM133.44 5.0464H134.078C134.254 5.05787 134.427 5.00181 134.563 4.88961C134.623 4.83449 134.671 4.76652 134.702 4.69068C134.733 4.61483 134.746 4.53303 134.742 4.45123C134.747 4.3708 134.733 4.29027 134.702 4.21591C134.671 4.14155 134.624 4.07535 134.563 4.02244C134.423 3.91882 134.252 3.86784 134.078 3.87844H133.44V5.0464ZM134.694 6.38395L134.056 5.2864H134.62L135.354 6.38395H134.694Z" fill="white"/>
          </g>
        </svg>
      </div>
    )
  }

  const webVersion = () => (
    <div className="signup-container">
      <div className="animated fadeIn signup-content col-lg-4 col-md-6 left p-3">
        {renderLogo()}
        {isStepThree ? (
          <div className="form-container-three">
            <div className="step-three-container">
              <StepThree
                changeEmail={changeEmail}
                dataRegister={dataRegister}
              />
            </div>
          </div>
        ) : (
          <div className="form-container">
            {isStepOne ? (
              <div className="step-one-container">
                <StepOne
                  initialValues={dataFormStep1}
                  errorGeneral={errorGeneral}
                  actionRegister={actionRegister}
                  loadingForm={loadingForm}
                  httpErrors={step1ServiceErrors}
                  goToStepTwo={goToStepTwo}
                />
              </div>
            ) : (
              <div className="step-one-container">
                <StepTwo
                  initialValues={dataFormStep2}
                  errorGeneral={errorGeneral}
                  loadingForm={loadingForm}
                  backStep={goToStepOne}
                  httpErrors={step2ServiceErrors}
                  goToStepThree={goToStepThree}
                />
              </div>
            )}
          </div>
        )}
        <div>
          <p className="bottom-container">
            {`${new Date().getFullYear()} ${I18n.t("dashboard_copyright")}`}
          </p>
          <LandingLocale
            direction='top'
            darkMode
          />
        </div>
      </div>
      <div className="col-lg-8 col-md-6 right overflow-hidden p-0">
        <img
          src={getStaticImage(isStepOne ? "/banner-signup-1.jpg" : "/banner-signup-2.png")}
          alt="Banner"
          className="w-100 h-100  object-fit-cover"
        />
      </div>
    </div>
  )

  // const mobileVersion = () => (
  //   <div className='signup-mobile'>
  //     <div className='logo-container'>
  //       <img src={'/img/logo-white.svg'} alt='Logo' />
  //     </div>
  //   </div>
  // );

  // const mobileVersion = () => (
  //   <div className="signup-mobile">
  //     <div className="logo-container">
  //       <img src={"/img/logo-white.svg"} alt="Logo" />
  //     </div>
  //     {isStepThree ? (
  //       <div className="aniamted fadeIn">
  //         <StepThree changeEmail={changeEmail} dataRegister={dataRegister} />
  //       </div>
  //     ) : (
  //       <div className="animated fadeIn">
  //         {isStepOne ? (
  //           <StepOne
  //             initialValues={dataFormStep1}
  //             errorGeneral={errorGeneral}
  //             actionRegister={actionRegister}
  //             loadingForm={loadingForm}
  //             httpErrors={step1ServiceErrors}
  //             goToStepTwo={goToStepTwo}
  //             isMobile={isMobile}
  //           />
  //         ) : (
  //           <StepTwo
  //             initialValues={dataFormStep2}
  //             errorGeneral={errorGeneral}
  //             loadingForm={loadingForm}
  //             httpErrors={step2ServiceErrors}
  //             backStep={goToStepOne}
  //             goToStepThree={goToStepThree}
  //           />
  //         )}
  //       </div>
  //     )}
  //   </div>
  // );

  React.useEffect(() => {
    if (actionRegister === "operator") {
      setLoadingInit(true)
      checkTokenOperator()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenOperator])

  if (loadingInit) {
    return <SignupLoadInit></SignupLoadInit>
  } else if (errorTokenOperator && actionRegister === "operator") {
    return (
      <SignupErrorInvalidToken
        title={I18n.t("nfrl_register_operator_error_token_title")}
        description={I18n.t("nfrl_register_operator_error_token_subtitle")}
      ></SignupErrorInvalidToken>
    )
  } else {
    // if (isMobile) {
    //   return mobileVersion();
    // } else {
    return webVersion()
    // }
  }
}

export default connect()(Signup)
